import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { HistoryBackActionContext, useHistoryBackAction } from '@/services/hooks/useHistoryBackAction';
import { palette, Paper } from '@dev/ee-components';

import { getSegmentsStore, SegmentsGetNamesStart, SegmentsLoadStart } from '@/store/segments/actions';
import useMobile from '@/services/hooks/useMobile';
import { getConfigStore } from '@/store/config/actions';
import { getCampaignsStore } from '@/store/campaigns/actions';
import { PaginationComponent } from './components/PaginationComponent';
import { WelcomeImageComponent } from './components/WelcomeImageComponent';
import { SearchComponent } from './components/SearchComponent';
import { TableComponent } from './components/TableComponent';
import { useRequestParams } from './hooks/useRequestParams';
import { StartCampaignCreator } from '../../CampaignCreator/Start';

const ScreenContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    & .MuiAlert-root {
        margin: 24px 0;
        color: ${palette.gray[7]};
    }
    & .MuiRadio-root {
        padding: 2px 9px;
    }
`;

const MobileWrapper = styled.div`
    border-top: 0;
    border-radius: 0 0 4px 4px;
`;

export const Segments: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const segments = useSelector(getSegmentsStore);
    const { isCampaignCreatorOpen } = useSelector(getCampaignsStore);
    const config = useSelector(getConfigStore);
    const params = useRequestParams();

    const isSavedRef = React.useRef(true);
 
    const historyBackAction = useHistoryBackAction({
        isSavedRef
    });

    useEffect(() => {
        const offset = params.page * params.perPage - params.perPage;
        dispatch(SegmentsLoadStart({ limit: params.perPage, offset, searchName: params.searchName }));
        if (!segments?.segmentNamesCollection) {
            dispatch(SegmentsGetNamesStart());
        }
    }, []);

    if (isMobile) {
        return (
            <ScreenContainer>
                <HistoryBackActionContext.Provider value={historyBackAction}>
                    <MobileWrapper>
                        <SearchComponent />
                        <TableComponent />
                        {!!segments?.currentCollectionTotalCount && <PaginationComponent />}
                    </MobileWrapper>
                </HistoryBackActionContext.Provider>
            </ScreenContainer>
        );
    }

    return (
        <ScreenContainer>
            <HistoryBackActionContext.Provider value={historyBackAction}>
                <Paper margin={{ top: config?.isStandalone ? 32 : -1 }} borderRadiusTop={!config?.isStandalone && 0}>
                    <WelcomeImageComponent />
                    <SearchComponent />
                    <TableComponent />
                    <PaginationComponent />
                </Paper>
                {isCampaignCreatorOpen && <StartCampaignCreator />}
            </HistoryBackActionContext.Provider>
        </ScreenContainer>
    );
};

export default Segments;
